import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import { usePagination } from '../../../../shared/hooks/use-pagination';
import styles from './client-groups-content.module.css';
import { UserSettings } from '../../../user/models/user-settings';
import { useGetClientGroupsQuery } from '../../api/client-groups-api';
import ClientGroupDeleteModal from '../client-group-delete-modal/client-group-delete-modal';
import ClientGroupFormModal from '../client-group-form-modal/client-group-form-modal';
import ClientGroupList from '../client-group-list/client-group-list';
import ClientGroupsTable from '../client-groups-table/client-groups-table';
import ClientGroupsHeader from '../client-groups-header/client-groups-header';

const ClientGroupsContent = (): JSX.Element => {
  const screens = useBreakpoint();
  const [searchParams] = useSearchParams();

  const [pageSize, setPageSize] = useState<number>();

  const { data: clientGroups, isFetching: isFetchingClientGroups } = useGetClientGroupsQuery(
    {
      name: searchParams.get('name') || '',
      page: Number(searchParams.get('page')) || 1,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      limit: pageSize!,
    },
    {
      skip: !pageSize,
    },
  );

  const [limit, pagination] = usePagination(clientGroups?.total, UserSettings.ClientGroupsPageSize);

  const clientGroupsDataSource = useMemo(() => {
    return (clientGroups && Array.isArray(clientGroups.items) ? clientGroups.items : []).map(
      ({ id, name, customers, users, templates, system }) => ({
        id,
        name,
        customers,
        users,
        templates,
        system,
      }),
    );
  }, [clientGroups]);

  useEffect(() => {
    setPageSize(limit);
  }, [limit]);

  return (
    <>
      <ClientGroupsHeader pagination={pagination} />
      {screens.sm ? (
        <div className={styles.contentContainer}>
          <ClientGroupsTable
            clientGroupsDataSource={clientGroupsDataSource}
            isFetchingClientGroups={isFetchingClientGroups}
          />
        </div>
      ) : (
        <ClientGroupList
          clientGroupsDataSource={clientGroupsDataSource}
          isFetchingClientGroups={isFetchingClientGroups}
        />
      )}

      <ClientGroupDeleteModal />
      <ClientGroupFormModal />
    </>
  );
};
export default ClientGroupsContent;
